import { useEffect } from 'react';
import * as Location from 'expo-location';
import { datadog } from '@sg/expo-datadog-client';

import { useTelemetry } from '@order/Telemetry';

/**
 * Passively reads the current location permission status and fires tracking
 * events once per app mount. Uses `getForegroundPermissionsAsync` so it never
 * triggers a system prompt — it only reads the existing OS-level setting.
 */
export function useLocationPermissionTracking() {
  const { track, setCustomerProperty } = useTelemetry();

  useEffect(() => {
    async function checkPermission() {
      const { status } = await Location.getForegroundPermissionsAsync();

      track('location.permission_result', { status });
      setCustomerProperty('location_permission_status', status);
      datadog.addAction('[Location] Permission Result', { status });
    }

    checkPermission();
  }, [track, setCustomerProperty]);
}
